import React from "react";
import { Search } from "lucide-react";

const PeerEmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-16 bg-white border border-dashed border-gray-300 rounded-lg flex-1 min-h-[500px]">
      <Search className="text-gray-300 w-10 h-10 mb-4" />
      <div className="max-w-md w-full mx-auto">
        <h2 className="text-lg font-medium text-gray-600 mb-2 tracking-tight">Who do you want to benchmark?</h2>
        <p className="text-sm text-gray-500 m-0 leading-relaxed">
          Search for an institution, faculty member, or unit above to find their most similar peers and compare performance metrics.
        </p>
      </div>
    </div>
  );
};

export default PeerEmptyState;
